import Splashpage from './splashpage';

export default Splashpage;
